import { render, staticRenderFns } from "./ItemArchive.vue?vue&type=template&id=7a116c5e&scoped=true&lang=pug&"
import script from "./ItemArchive.vue?vue&type=script&lang=js&"
export * from "./ItemArchive.vue?vue&type=script&lang=js&"
import style0 from "./ItemArchive.vue?vue&type=style&index=0&id=7a116c5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a116c5e",
  null
  
)

export default component.exports